import React, { Component, PropTypes } from 'react';
import ReactDom from 'react-dom';
import './app'; 
 import './app.css'; 
 class Index extends Component {
		render() {
			return null;
		}
}
export default ReactDom.render(<Index />, document.querySelector('#app'))